module.exports = __webpack_public_path__ + "static/media/Invest_In_Vision.e2776643.jpg";